import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';

export const Navbar = () => {
  const navigate = useNavigate();
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Home', href: '#home' },
    { name: 'Roulette', href: '#roulette' },
    { name: 'How It Works', href: '#how-it-works' },
    { name: 'Features', href: '#features' },
    { name: 'FAQ', href: '#faq' },
  ];

  const scrollTo = (href) => {
    setMobileMenuOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-[#0f111a]/95 backdrop-blur-md shadow-lg border-b border-gray-800' : 'bg-transparent'}`}>
      <div className="container mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between h-20">
          
          {/* Logo */}
          <div className="flex-shrink-0 flex items-center gap-3 cursor-pointer" onClick={() => scrollTo('#home')}>
            <div className="w-10 h-10 rounded-full border border-gold-500 flex items-center justify-center bg-transparent">
              <div className="w-6 h-6 border-2 border-gold-500 rounded-full flex items-center justify-center">
                 <div className="w-2.5 h-2.5 bg-gold-500 rounded-full" />
              </div>
            </div>
            <span className="text-xl md:text-2xl font-serif text-white tracking-widest uppercase mt-1">
              ROYAL <span className="text-gold-500">ROULETTE</span>
            </span>
          </div>

          {/* Desktop Nav */}
          <div className="hidden lg:flex items-center space-x-8">
            {navLinks.map((link) => (
              <button
                key={link.name}
                type="button"
                onClick={() => scrollTo(link.href)}
                className="text-gray-100 hover:text-gold-500 text-sm font-semibold transition-colors bg-transparent border-0 cursor-pointer"
              >
                {link.name}
              </button>
            ))}
          </div>

          {/* Desktop Auth & CTA */}
          <div className="hidden lg:flex items-center space-x-4">
             
             <button
               type="button"
               onClick={() => navigate('/login')}
               className="text-gold-500 border border-gold-600 hover:bg-gold-500/10 text-sm font-medium px-5 py-2 rounded-full transition-all cursor-pointer"
             >
               Login
             </button>
            
          </div>

          {/* Mobile Menu Button */}
          <div className="lg:hidden flex items-center">
            <button
              type="button"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="text-gold-500 p-2 bg-transparent border-0 cursor-pointer"
            >
              {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence>
        {mobileMenuOpen && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0 }}
            className="lg:hidden bg-charcoal-900 border-b border-gray-800 overflow-hidden"
          >
            <div className="px-4 pt-2 pb-6 space-y-4">
              {navLinks.map((link) => (
                <button
                  key={link.name}
                  type="button"
                  onClick={() => scrollTo(link.href)}
                  className="block w-full text-left px-3 py-2 text-base font-medium text-gray-300 hover:text-gold-500 hover:bg-charcoal-800 rounded-md bg-transparent border-0"
                >
                  {link.name}
                </button>
              ))}
              <div className="pt-4 flex flex-col gap-3 px-3">
                 <button
                   type="button"
                   onClick={() => { setMobileMenuOpen(false); navigate('/login'); }}
                   className="w-full text-center border border-gray-700 text-white py-3 rounded-full font-bold bg-transparent cursor-pointer"
                 >
                   Login
                 </button>
                <button
                  type="button"
                  onClick={() => scrollTo('#roulette')}
                  className="w-full bg-gold-500 text-black py-3 rounded-full font-bold shadow-lg shadow-amber-500/20 cursor-pointer"
                >
                  PLAY DEMO NOW
                </button>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </nav>
  );
};
